import { getDatesArray } from 'components/shared/processes'
import { useState } from 'react'

export const useGetRangeDate = () => {
	const weekDays = getDatesArray(6)
	const [dateRange, setDateRange] = useState({
		startDate: weekDays.startDate,
		endDate: weekDays.endDate,
	})

	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}
	return { dateRange, onChangeCallback }
}
